import { useEffect } from 'react'
import { useTheme } from '@mui/material/styles'

import { useAppDispatch, useAppSelector } from 'redux/Hook'
import MultiSelectWithSearch from 'components/Shared/MultiSelectWithSearch'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import { ReportingFilterTypes } from 'types/ReportingFilterBuilderContext'
import { trackActions } from 'containers/Helper'
import { FilterItem } from 'types/FilterBuilder'
import { updateFilter } from 'redux/slices/FilterBuilder'

type Props = {
  item: FilterItem
  index: number
  isAutoFocusEnabled: boolean
}

const Hubs = (props: Props) => {
  const dispatch = useAppDispatch()

  const {
    item: { value },
    index,
    isAutoFocusEnabled,
  } = props
  const {
    features: { features: currentFeatures = [] } = {},
    hubs: { data: hubs = [] } = {},
  } = useAppSelector((state) => state)

  const isOptionEqualToValue = (
    option: { name: string },
    value: { name: string },
  ) => {
    return option.name === value.name
  }

  useEffect(() => {
    trackActions('Clicked on Hub filter option', {
      featureName: 'Overview dashboard filters',
      sectionName: 'Overview (Home) Dashboard page',
      ...currentFeatures?.['segment_analytics_admin']?.enabled,
    })
  }, [])

  const onChangeHubs = (value: ReportingFilterTypes) => {
    dispatch(
      updateFilter({
        item: { value },
        index,
      }),
    )
  }

  const theme: AdminUITheme = useTheme()

  return (
    <MultiSelectWithSearch
      style={theme.GenericTheme.dynamicFilterWrapperWidth}
      isOptionEqualToValue={isOptionEqualToValue}
      selectedValues={value || []}
      options={hubs}
      handleOnChange={(value: ReportingFilterTypes) => onChangeHubs(value)}
      defaultOpen={isAutoFocusEnabled}
      optionKey="name"
      dataCyLabel="hubs"
      labelKey="filters.hub.label"
      placeholderKey="filters.search"
      isLoaderEnabled={true}
    />
  )
}

export default Hubs
